<template>
  <v-container fluid>
    <!-- Loading bar -->
    <v-row justify="center" align="center">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="red"
        class="w-100"
      />
    </v-row>

    <!-- Data Iterator (replaced with custom grid since Vuetify 3 removed it) -->
    <v-row>
      <v-col
        v-for="item in paginatedParts"
        :key="item.key"
        cols="12"
        md="6"
        lg="4"
        xl="3"
      >
        <v-card class="ma-2 pa-2">
          <v-card-text class="text-black">
            <p v-if="item.group === 'date'">
              {{ $t("parts.insert_parts.empty_parts.date_created") }}:
              <strong>{{ formatDate(item.key) }}</strong>
            </p>

            <p v-else-if="item.group === 'shipment'">
              {{ $t("parts.insert_parts.empty_parts.shipment") }}:
              <strong>
                {{
                  item.key && item.opt
                    ? item.opt.name
                    : $t("parts.insert_parts.empty_parts.empty")
                }}
              </strong>
            </p>

            <p>
              {{ $t("parts.insert_parts.empty_parts.number_of_parts") }}:
              <strong>{{ item.parts.length }}</strong>
            </p>
          </v-card-text>

          <v-divider class="my-2" />

          <v-card-actions class="d-flex flex-column ga-2">
            <v-btn
              color="primary"
              size="small"
              variant="outlined"
              @click="openQrCodes(item.parts)"
            >
              {{ $t("parts.insert_parts.empty_parts.open_qr_codes") }}
              <v-icon end>mdi-qrcode</v-icon>
            </v-btn>

            <v-btn
              :disabled="disabled || !item.key"
              color="error"
              size="small"
              variant="outlined"
              @click="deleteEmptyParts(item.group, item.key)"
            >
              {{ $t("parts.insert_parts.empty_parts.delete_qr_codes") }}
              <v-icon end>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Pagination Controls -->
    <v-row class="mt-4" justify="center" align="center">
      <v-col class="d-flex justify-center">
        <v-pagination
          v-model="pagination.page"
          :length="Math.ceil(totalItems / pagination.rowsPerPage)"
          total-visible="4"
        />
      </v-col>
      <v-col md="3">
        <v-select
          v-model="pagination.rowsPerPage"
          :items="[4, 8, 16, 24]"
          label="Items per page"
          density="compact"
          class="mr-1"
        />
      </v-col>
    </v-row>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert type="error" variant="tonal" border="bottom">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import getRequest from "../../api/getRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  props: {
    groupby: String,
  },
  data: () => ({
    loading: false,
    parts: [],
    totalItems: 0,
    pagination: {
      rowsPerPage: 4,
      page: 1,
    },
    dialogDelete: false,
    deletePayload: { group: null, key: null },
  }),
  computed: {
    groupBy() {
      return this.groupby;
    },
    disabled() {
      const role = this.$store.getters.role;
      return !["LekoAdmin", "InstitutionAdmin", "SuperAdmin"].includes(role);
    },
    paginatedParts() {
      return this.parts;
    },
  },
  watch: {
    groupBy: "getEmptyParts",
    pagination: {
      handler: "getEmptyParts",
      deep: true,
    },
  },
  mounted() {
    this.getEmptyParts();
  },
  methods: {
    formatDate(date) {
      moment.locale(localStorage.getItem("language"));
      return moment(date).format("LLL");
    },
    getEmptyParts() {
      this.loading = true;
      const groupBy =
        this.groupBy === "date" || this.groupBy === "shipment"
          ? this.groupBy
          : "date";

      getRequest(
        "/temporary-part/insert/empty-grouped/",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.rowsPerPage}&page=${this.pagination.page}&group_by=${groupBy}`,
      )
        .then((response) => {
          this.parts = response.emptyParts;
          this.totalItems = response.count;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    deleteEmptyParts(group, key) {
      this.deletePayload = { group, key };
      this.dialogDelete = true;
    },
    confirmDelete() {
      const { group, key } = this.deletePayload;
      deleteRequest(
        "/temporary-part/insert/empty",
        `group=${group}&key=${key}&user_id=${
          this.$store.getters.userId
        }&institution_id=${
          this.$store.getters.institutionId
        }&role=${this.$store.getters.role}`,
      )
        .then(() => this.getEmptyParts())
        .catch((error) => {})
        .finally(() => {
          this.deletePayload = { group: null, key: null };
          this.dialogDelete = false;
        });
    },
    openQrCodes(data) {
      this.$emit("qr", data);
    },
  },
};
</script>
